var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"brdr-none bg-cl-transparent"},[_vm._v("\n  "+_vm._s(_vm.$t('Remove'))+"\n  "),_c('i',{staticClass:"material-icons h6"},[_vm._v("remove_shopping_cart")])])}
var staticRenderFns = []

export { render, staticRenderFns }